import {MithrilComponent} from '@bitstillery/mithril'
import {Button, Dialog} from '@bitstillery/common/components/portal'
import {format_money_responsive} from '@bitstillery/common/lib/format'
import {$t} from '@bitstillery/common/app'
import m from '@bitstillery/mithril'
import {dayjs} from '@bitstillery/common/lib/utils'

import {$s} from '@/app'
import {CarouselGiveAway} from '@/components/promotion/carousel_giveaway'
import {PromotionTerms} from '@/components/promotion/terms'

interface PopupPromotionAttrs {
    onclose: () => void
}

export class PopupPromotion extends MithrilComponent<PopupPromotionAttrs> {
    view(vnode: m.Vnode<PopupPromotionAttrs>) {
        const days_left = Math.abs(dayjs().diff(dayjs($s.promotion.end_date), 'day'))
        return (
            <Dialog
                icon='promotion'
                onclose={vnode.attrs.onclose.bind(this)}
                title={`${$s.promotion.slogan} (${$t('promotions.label.promotion')})`}
                className='c-dialog-promotion'
            >
                <CarouselGiveAway
                    slides={[
                        {
                            url: '/img/promotions/banner.jpg',
                        },
                        ...$s.promotion.gifts.map((option, i) => ({
                            description: option.description,
                            link: option.link,
                            title: option.title,
                            url: `/img/promotions/nl-action-${i}.jpg`,
                        })),
                    ]}
                />
                <div className='l-promotion'>
                    <div className='wrapper'>
                        <div className='promotion-text'>
                            {$t('promotions.label.dialog_subtitle', {
                                currency: $s.identity.user.currency,
                                token_value: format_money_responsive(
                                    $s.promotion.token_value,
                                    undefined,
                                    $s.identity.user.currency,
                                ),
                            })}
                        </div>
                        <Button
                            className='btn-cta'
                            icon='cart'
                            link={'/shop'}
                            onclick={vnode.attrs.onclose.bind(this)}
                            text={$t('promotions.call_to_action')}
                            type='info'
                        />
                        <PromotionTerms />
                    </div>
                    {days_left <= 7 && (
                        <span className='incentive-hurry'>{$t('promotions.incentive_hurry', {count: days_left})}</span>
                    )}
                </div>
            </Dialog>
        )
    }
}
